<template>
  <a-carousel autoplay arrows :autoplaySpeed="7000">
    <template #prevArrow>
      <div class="custom-slick-arrow" style="left: 10px; z-index: 1000">
        <left-circle-outlined />
      </div>
    </template>
    <template #nextArrow>
      <div class="custom-slick-arrow" style="right: 10px">
        <right-circle-outlined />
      </div>
    </template>
    <div>
      <a href="/claim-prize">
        <img style="width: 100%;" src="https://daosen-crm.oss-accelerate.aliyuncs.com/prod/qrkj/uploads/ueditor/image/20250725/1753430491676205.jpeg" />
      </a>
    </div>
    <div>
      <a href="/claim-prize">
        <img style="width: 100%;" src="https://daosen-crm.oss-accelerate.aliyuncs.com/prod/qrkj/uploads/ueditor/image/20250319/1742367430126949.png" />
      </a>
    </div>
  </a-carousel>

  <div :style="'background-color: #ffffff;' + (isMobile ? '':'padding: 50px 100px 0 100px')">
    <div style="color: black; margin-left: 0; font-size: xx-large;margin-top: -30px;"><b>Shop our top categories</b></div>
    <a-row :gutter="[16, 24]">
      <a-col :xs="24" :sm="12" :md="8" :lg="6">
        <a target="_blank" href="https://www.dealnewspaper.com/products/kylore-portable-personal-blender-for-shakes-and-smoothies-with-27oz-cup-and-lid-type-c-rechargeable-dishwasher-safe-parts-bpa-free-with-shoulder-strap-for-sports-travel-hiking-office-school?spm=..product_862ecdfc-fb8f-4826-8f13-98043d06e759.header_1.1&spm_prev=..product_0509fb3d-9ac7-488c-ac09-c5cafea38dbf.header_1.1">
          <a-card hoverable>
            <template #cover>
              <img alt="example" src="https://cdn.shoplazza.com/074a50e6abfcd48f54a390c472d310f1_1024x.jpg" />
            </template>
            <a-card-meta title="Portable Blender">
              <template #description>
                <span style="color: black;">Portable Personal Blender for Shakes and Smoothies with 27oz Cup and Lid, Type-C Rechargeable, Dishwasher Safe Parts, BPA free, with Shoulder Strap, for Sports/Travel/Hiking/Office/School</span>
              </template>
            </a-card-meta>
          </a-card>
        </a>
      </a-col>
      <a-col :xs="24" :sm="12" :md="8" :lg="6">
        <a target="_blank" href="https://www.dealnewspaper.com/products/agreago-auto-focus-keystone-projector-with-wifi-6-and-bluetooth-5-2-600-ansi-native-1080p-4k-supported-agreago-outdoor-projector-with-screen-movie-projector-compatible-with-hdmi-usb-tv-stick?spm=..product_dbd2111a-1675-459c-822d-673d30bb363f.header_1.1&spm_prev=..product_862ecdfc-fb8f-4826-8f13-98043d06e759.header_1.1">
          <a-card hoverable>
            <template #cover>
              <img alt="example" src="https://cdn.shoplazza.com/1184d5206e10ca41f69f6cf2d9809d9b_1024x.jpg" />
            </template>
            <a-card-meta title="Projector">
              <template #description>
                <span style="color: black;">AGREAGO [Auto Focus/Keystone] Projector with WiFi 6 and Bluetooth 5.2, 600 ANSI Native 1080P 4K Supported, Agreago Outdoor Projector with Screen, Movie Projector Compatible with HDMI/USB/TV Stick</span>
              </template>
            </a-card-meta>
          </a-card>
        </a>
      </a-col>
      <a-col :xs="24" :sm="12" :md="8" :lg="6">
        <a target="_blank" href="https://www.dealnewspaper.com/products/prasky-air-purifiers-for-home-air-purifiers-for-home-large-room-up-to-1076ft-h13-true-hepa-air-filter-with-fragrance-sponge-25db-quiet-air-purifiers-for-bedroom-smoke-pet-dander-dust-pollen-odor?spm=..product_b044d72a-a1ae-4cdf-9c9a-effded59c513.header_1.1&spm_prev=..product_dbd2111a-1675-459c-822d-673d30bb363f.header_1.1">
          <a-card hoverable>
            <template #cover>
              <img alt="example" src="https://cdn.shoplazza.com/b00dc2075741da2934dd1f31c7ca73bc_1024x.jpg" />
            </template>
            <a-card-meta title="Air Purifiers">
              <template #description>
                <span style="color: black;">PRASKY Air Purifiers for Home, Air Purifiers for Home Large Room Up to 1076Ft², H13 True HEPA Air Filter with Fragrance Sponge, 25dB Quiet Air Purifiers for Bedroom Smoke Pet Dander Dust Pollen Odor</span>
              </template>
            </a-card-meta>
          </a-card>
        </a>
      </a-col>
      <a-col :xs="24" :sm="12" :md="8" :lg="6">
        <a target="_blank" href="https://www.dealnewspaper.com/products/prasky-electric-spin-scrubber-cordless-cleaning-brush-with-adjustable-extension-arm-7-brush-heads-power-shower-scrubber-for-bathroom-tub-tile-kitchen-white-balck?spm=..product_0509fb3d-9ac7-488c-ac09-c5cafea38dbf.header_1.1&spm_prev=..product_b044d72a-a1ae-4cdf-9c9a-effded59c513.header_1.1">
          <a-card hoverable>
            <template #cover>
              <img alt="example" src="https://cdn.shoplazza.com/af7b45064efe925e88ebc947a679778b_1024x.jpg" />
            </template>
            <a-card-meta title="Electric Spin Scrubber">
              <template #description>
                <span style="color: black;">PRASKY Electric Spin Scrubber, Cordless Cleaning Brush with Adjustable Extension Arm & 7 Brush Heads, Power Shower Scrubber for Bathroom, Tub, Tile, Kitchen (White&balck)</span>
              </template>
            </a-card-meta>
          </a-card>
        </a>
      </a-col>
    </a-row>
  </div>

  <div style="height: 100px; background: white;"></div>
</template>

<script setup>
import {inject} from "vue";
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons-vue';

const isMobile = inject('isMobile');
const showLogin = inject('showLogin');
showLogin.value = false;

</script>

<style scoped>
/* For demo */
:deep(.slick-dots) {
  position: relative;
  height: auto;
}
:deep(.slick-slide img) {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 100%;
}
:deep(.slick-arrow) {
  display: none !important;
}
:deep(.slick-thumb) {
  bottom: 0px;
}
:deep(.slick-thumb li) {
  width: 60px;
  height: 45px;
}
:deep(.slick-thumb li img) {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
  display: block;
}
:deep .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}


/**轮播样式**/
.ant-carousel :deep(.slick-slide) {
  text-align: center;
  line-height: 160px;
  background: white;
  overflow: hidden;
}
.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
  width: 35px;
  height: 55px;
  font-size: 35px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
  z-index: 1;
}
.ant-carousel :deep(.custom-slick-arrow:before) {
  display: none;
}
.ant-carousel :deep(.custom-slick-arrow:hover) {
  opacity: 0.5;
}
.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}
:deep(.custom-slick-arrow) {
  display: flex !important;  /* 关键：必须强制显示 */
  position: absolute;       /* 定位必须设置 */
}
</style>
